import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Card } from '@material-ui/core';

import { AscendState } from '../../ducks';
import { CLEAR_ACCOUNTS_CACHE, CLEAR_CONNECT_URL, FETCH_CONNECT_URL } from '../../ducks/actions';

type StateProps = {
  connectUrl: string;
  connectUrlLoading: boolean;
  userId: number;
};
type DispatchProps = {
  clearAccountsCache: (userId: number) => void;
  clearConnectUrl: () => void;
  getConnectUrl: (userId: number) => void;
};
type ConnectFrameProps = StateProps & DispatchProps;

const ConnectFrame = ({
  clearAccountsCache,
  clearConnectUrl,
  connectUrl,
  connectUrlLoading,
  getConnectUrl,
  userId,
}: ConnectFrameProps) => {
  const clearUserAccountsCache = useCallback(() => clearAccountsCache(userId), [userId]);

  useEffect(() => {
    if (!userId) return;
    getConnectUrl(userId);

    return () => clearConnectUrl();
  }, [userId]);

  useEffect(() => {
    const eventListener = (event: any) => {
      if (event.origin !== 'https://widgets.moneydesktop.com') return;
      const data = JSON.parse(event.data);
      if (['agg_success', 'created', 'mxConnect:memberAdded'].includes(data.type))
        clearUserAccountsCache();
    };

    window.addEventListener('message', eventListener);
    return () => window.removeEventListener('message', eventListener);
  }, [clearUserAccountsCache]);

  return (
    <Card elevation={2}>
      {connectUrlLoading && (
        <div
          style={{
            border: 'none',
            height: '80vh',
            width: '100%',
            paddingTop: '2rem',
            textAlign: 'center',
          }}>
          Opening Account Integration Options...
        </div>
      )}
      {!connectUrlLoading && (
        <iframe src={connectUrl} style={{ border: 'none', height: '80vh', width: '100%' }} />
      )}
    </Card>
  );
};

const mapStateToProps = (state: AscendState) => ({
  connectUrl: state.mx.connectUrl.data,
  connectUrlLoading: state.mx.connectUrl.loading,
  userId: state.user.data.id,
});

// noinspection JSUnusedGlobalSymbols
const mapDispatchToProps = (dispatch: Dispatch) => ({
  clearAccountsCache: (userId: number) => dispatch({ type: CLEAR_ACCOUNTS_CACHE, userId }),
  clearConnectUrl: () => dispatch({ type: CLEAR_CONNECT_URL }),
  getConnectUrl: (userId: number) => dispatch({ type: FETCH_CONNECT_URL, userId }),
});

export default connect<StateProps, DispatchProps, {}>(
  mapStateToProps,
  mapDispatchToProps
)(ConnectFrame);
